//
//
//
//
//
//
//
//

import Vue from 'vue'

import domel from '~/components/domel'


import RestModelDummy from '~/components/rest-model-dummy'
import RestImgDummy from '~/components/rest-img-dummy'
import RestStringDummy from '~/components/rest-string-dummy'
// import RestStringLinkDummy from '~/components/rest-string-link-dummy'
import RestPropDummy from '~/components/rest-prop-dummy'
import RestPropLinkDummy from '~/components/rest-prop-link-dummy'
// import RestDateDummy from '~/components/rest-date-dummy'
import RestRichTextDummy from '~/components/rest-rich-text-dummy'
// import RestReorderListDummy from '~/components/rest-reorder-list-dummy'
import CmsEditDummy from '~/components/cms-edit-dummy'
// import Quotes from '~/components/quotes'
import FullCourseList from '~/components/full-course-list'

import page from "./blended-learning.js"

let components = page.components;
// delete page.components;

export default {
	name: 'blended-learning-index',

	...page,

	layout: 'courses',

	components:
	{
		...components,

		// you *MUST* declare components before you can use them
		'rest-img': RestImgDummy,
		'rest-prop': RestPropDummy,
		'rest-rich-text': RestRichTextDummy,
		'rest-model': RestModelDummy,
		'rest-link': RestPropLinkDummy,
		'rest-prop-link': RestPropLinkDummy,
		'rest-string': RestStringDummy,
		// 'rest-string-link': RestStringLinkDummy,
		// 'rest-date': RestDateDummy,
		// 'rest-date-add': RestDateAdd,
		// 'rest-reorder-list': RestReorderListDummy,
		'cms-edit': CmsEditDummy,
		// Quotes,
		FullCourseList,
		// RestListItemAdd,
		// RestItemAdd,
		// RestItemRemovable,
		// TagInput,
	}
}

